import React from "react";

export default function MobileCallButton() {
  // Function to fire the conversion tracking event on click
  // const handleCallConversion = () => {
  //   if (typeof window !== "undefined" && typeof window.gtag === "function") {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-18343552397/rJAbCNm_2NYcEI3L8apE",
  //     });
  //   }
  // };

  const handleCallClick = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "phone_click", {
        event_category: "engagement",
        event_label: "TripReserver phone number",
      });
    }
  };

  return (
    // Fixed to the bottom, high z-index to stay on top, hidden on large screens
    <div className="fixed bottom-0 left-0 z-50 w-full border-t border-slate-200 bg-white/95 p-3 shadow-[0_-12px_30px_rgba(15,23,42,0.1)] backdrop-blur-xl lg:hidden">
      {/* Anchor tag with 'tel:' link so it actually opens the phone dialer on mobile */}
      <a
        href="tel:+18889771997"
        onClick={handleCallClick}
        className="mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-full bg-[#2871d3] py-3 text-[15px] font-extrabold tracking-wide text-white shadow-lg shadow-blue-600/20 transition-colors hover:bg-[#155bc2] active:bg-[#155bc2]"
      >
        {/* Telephone SVG Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
          className="h-5 w-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.896-1.596-5.48-4.18-7.076-7.076l1.293-.97c.362-.271.527-.733.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
          />
        </svg>
        CALL NOW 1-888-977-1997
      </a>
    </div>
  );
}
